import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export const tabIds = {
  "installation-date": 0,
  "add-ons": 1,
  "pay-deposit": 2
};

interface AccountState {
  tabSelected: "installation-date" | "add-ons" | "pay-deposit";
  step: number;
  date?: number;
  dateChangeable: boolean;
  timer?: number;
  openSummary: boolean;
}

const initialState: AccountState = {
  tabSelected: "installation-date",
  step: 0,
  openSummary: false,
  dateChangeable: true
};

const checkout = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    updateTabSelected(state, { payload }: PayloadAction<"installation-date" | "add-ons" | "pay-deposit">) {
      state.tabSelected = payload;
      state.step = tabIds[payload];
    },
    updateDateSelected(state, { payload }: PayloadAction<number | undefined>) {
      state.date = payload;
      state.timer = payload ? Date.now() + 1000 * 600 : undefined;
      state.dateChangeable = !payload;
    },
    openSummary(state) {
      state.openSummary = true;
    },
    closeSummary(state) {
      state.openSummary = false;
    },
    makeDateChangeable(state) {
      state.dateChangeable = true;
    }
  }
});

export const { updateTabSelected, updateDateSelected, openSummary, closeSummary, makeDateChangeable } =
  checkout.actions;

export default checkout.reducer;
